export const environment = {
    production: false,
    url: "",
    ApiUrl: "https://tcapitest.clavisco.com/",
    env: "Test",
};
